import { TextElementEnum } from '../../types';

export const fontSizeDecorator = (size?: TextElementEnum) => {
	switch (size) {
		case 'h1':
			return 'font-size: 3rem;';
		case 'h2':
			return 'font-size: 2.4rem;';
		case 'h3':
			return 'font-size: 2rem;';
		case 'h4':
			return 'font-size: 1.6rem;';
		case 'h5':
			return 'font-size: 1.25rem;';
		case 'h6':
			return 'font-size: 1rem;';
		case 'small':
			return 'font-size: 0.64rem;';
		case 'p':
			return 'font-size: 1rem;';
		case 'span':
		default:
			return 'font-size: 0.8rem;';
	}
};
